<template lang="pug">
  svg.svg-plant(:x="x" :y="y" :width="width" :height="height" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet")
    title Plant
    g.left-leaves
      path.plant-cls-1(d="M54.54,55.62C48.28,49.37,39.15,41.78,30,41.27c-1.93-.11-1.92,2.89,0,3,8,.44,17,8,22.43,13.47a1.5,1.5,0,0,0,2.12-2.12Z")
      path.plant-cls-1(d="M21.6,27.06C26,32.4,31.51,36,36.24,40.89c4.94,5.13,11.72,9,15,15.53.86,1.73,3.44.21,2.59-1.52-3.1-6.27-9.29-10.34-14.27-15-5.33-5-11.14-9.32-15.81-15-1.23-1.49-3.34.64-2.12,2.12Z")
      path.plant-cls-1(d="M44.69,13.84c1.58,14.43,6,28.38,7.29,42.84.17,1.91,3.18,1.92,3,0-1.32-14.47-5.71-28.41-7.29-42.84-.21-1.9-3.21-1.92-3,0Z")
      ellipse.plant-cls-2(cx="13.03" cy="27.62" rx="14.3" ry="5.54" transform="translate(-12.52 10.89) rotate(-31.53)")
      ellipse.plant-cls-2(cx="20.83" cy="43.42" rx="14.13" ry="15.29")
      ellipse.plant-cls-2(cx="40.32" cy="10.8" rx="8.3" ry="9.16" transform="translate(-1.17 6.2) rotate(-8.67)")
    g.right-leaves
      path.plant-cls-1(d="M60.66,3.25c-1.51,8.64-3.45,17.33-4.4,26.05-.49,4.52-.39,9-1.16,13.48S53.28,52,52.36,56.54c-.37,1.88,2.52,2.69,2.9.8C56.91,49.1,58.52,41.16,59,32.78c.56-9.62,2.9-19.25,4.55-28.73.33-1.89-2.56-2.7-2.89-.8Z")
      path.plant-cls-1(d="M73.45,25.08c-8,9.41-13.36,20.78-21,30.54-1.18,1.5.93,3.64,2.12,2.12,7.66-9.75,13-21.15,21-30.54,1.25-1.46-.86-3.59-2.12-2.12Z")
      path.plant-cls-1(d="M80.87,36.09c-7.4-2.28-12,1.61-18.12,4.93C56.84,44.21,53.73,50,52,56.28a1.51,1.51,0,0,0,2.9.8c1.5-5.58,4.1-10.64,9.33-13.47S73.92,37.09,80.08,39c1.84.57,2.63-2.33.79-2.9Z")
      ellipse.plant-cls-2(cx="88.22" cy="42" rx="9.89" ry="15.42" transform="translate(-9.44 45.19) rotate(-27.33)")
      ellipse.plant-cls-2(cx="82.23" cy="25.58" rx="5.6" ry="12.21" transform="translate(40.09 100.68) rotate(-77.98)")
      ellipse.plant-cls-2(cx="68.59" cy="4.17" rx="3.57" ry="13.16" transform="translate(59.78 72.32) rotate(-86.12)")
    ellipse.plant-cls-2(cx="54.16" cy="44.29" rx="8.2" ry="14.59" transform="translate(-10.5 71.01) rotate(-61.73)")
    polygon.plant-cls-3(points="70.05 99.5 35.94 99.5 31.06 55.66 74.92 55.66 70.05 99.5")
</template>

<script>
export default {
  name: 'svg-plant',

  props: {
    x: Number,
    y: Number,
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    },
  },

};
</script>

<style lang="scss" scoped>
.svg-plant {

  .left-leaves,.right-leaves {
    transition: transform 1s;
    transform-origin: 50px 50px;
  }

  .left-leaves {
    animation: wiggle-right 1s linear infinite alternate;
    animation-play-state: paused;
  }

  .right-leaves {
    animation: wiggle-left 1s linear infinite alternate;
    animation-play-state: paused;
  }

  @keyframes wiggle-right {
    100% { transform: rotate(2deg); }
  }

  @keyframes wiggle-left {
    100% { transform: rotate(-2deg); }
  }

  .plant-cls-1 {
    fill: var(--fill-color-1, #006837);
    stroke: var(--stroke-color-1, none);
    stroke-width: var(--stroke-width-1, 1px);
    stroke-miterlimit: 4;
    vector-effect: non-scaling-stroke;
  }
  .plant-cls-2 {
    fill: var(--fill-color-2, #009245);
    stroke: var(--stroke-color-2, #006837);
    stroke-width: var(--stroke-width-2, 1px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
  .plant-cls-3 {
    fill: var(--fill-color-3, #a43d2d);
    stroke: var(--stroke-color-3, #000);
    stroke-width: var(--stroke-width-3, 1px);
    stroke-miterlimit: 10;
    vector-effect: non-scaling-stroke;
  }
}

// .svg-plant:hover {
//   .left-leaves,.right-leaves {
//     animation-play-state: running;
//   }
// }

</style>
